module.exports = __webpack_public_path__ + "static/media/close-black.31b23e1d.svg";